module.exports = __webpack_public_path__ + "static/travelzik1bwm-df54cf368604c1c756ab80a7608ccfa9.jpg";